module.exports = __webpack_public_path__ + "img/scroll-arrow-to-up.1a60b338.svg";